var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSticker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0H0V34H9L10.2 17.6667L9 0Z",
    fill: "#FF6A6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 0V17L16 10.0223L17 5L16 0L9 0Z",
    fill: "#D4E6FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 0H16V10.0223L23 34H32V0Z",
    fill: "#B2D9FD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8398 12.2941C11.0212 12.2179 14.3565 17.0837 14.3565 17.0837L16.001 15.561L16.8343 12.6335L16.001 10.0225C15.3766 10.2973 11.4684 12.0175 10.8398 12.2941Z",
    fill: "#B2D9FD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23 12.0607L25 11.0607C25 8.70514 22.5797 7.12594 20.4237 8.07501C19.2274 8.60154 16.7088 9.71007 16 10.0221V15.5607L19.7111 14.6113L23 12.0607Z",
    fill: "#96C9F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.061C15 15.7113 15 15.4108 15 15.061C15 13.4042 13.6569 12.061 12 12.061C11.6052 12.061 11.2117 12.1376 10.8389 12.2942C10.8321 12.2972 10.8 12.3113 10.8068 12.3083C10.7933 12.3142 10.78 12.3204 10.7665 12.3265C10.7599 12.3299 10.5028 12.4612 10.5114 12.4568C9.58987 12.9848 9 13.9672 9 15.061V34.0002H16L16.5 25.0002L16 15.561C15.6503 15.7359 15.3497 15.8862 15 16.061Z",
    fill: "#FFD900"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23 12.061L16 15.561V34.0002H23V12.061Z",
    fill: "#FFB227"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.17773 4H5.17773V6H3.17773V4Z",
    fill: "#FFD900"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.17773 12H5.17773V14H3.17773V12Z",
    fill: "#FFD900"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.17773 20H5.17773V22H3.17773V20Z",
    fill: "#FFD900"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.17773 28H5.17773V30H3.17773V28Z",
    fill: "#FFD900"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22H20C20 21.3005 20 20.6995 20 20H18V22Z",
    fill: "#FF1B79"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20H14V22H12V20Z",
    fill: "#FF6A6E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18 30H20V28C19.3005 28 18.6995 28 18 28V30Z",
    fill: "#FF1B79"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12 28H14V30H12V28Z",
    fill: "#FF6A6E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15 24V26H16L16.5 25L16 24C15.6503 24 15.3497 24 15 24Z",
    fill: "#FF6A6E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16 24H17V26H16V24Z",
    fill: "#FF1B79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSticker);
export default __webpack_public_path__ + "static/media/Sticker.8b31dcb7d1a7d04b1de94367b84d5d1b.svg";
export { ForwardRef as ReactComponent };